import { render, staticRenderFns } from "./deliverDialog.vue?vue&type=template&id=2b2a0902&scoped=true&"
import script from "./deliverDialog.vue?vue&type=script&lang=js&"
export * from "./deliverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a0902",
  null
  
)

export default component.exports